import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const foereservationApi = api
  .enhanceEndpoints({ addTagTypes: ['FOEReservation'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOEReservations: builder.query<any[], string>({
        query: cid => `foereservation/${cid}`,
        providesTags: ['FOEReservation'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (
                data.type === 'FRONT_OFFICE_UPDATED' ||
                data.type === 'RESERVATION_UPDATED'
              ) {
                dispatch(
                  foereservationApi.util.invalidateTags(['FOEReservation'])
                );
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getFOEReservationById: builder.query<any, string>({
        query: id => `foereservation/byid/${id}`,
        providesTags: ['FOEReservation']
      }),
      getFOEReservationByDate: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) =>
          `foereservation/bydate/${cid}/${fdt}/${tdt}`,
        providesTags: ['FOEReservation']
      }),
      getFOEReservationByOccDate: builder.query<any, any>({
        query: ({ cid, type, fdt, tdt }) =>
          `foereservation/byoccdate/${cid}/${type}/${fdt}/${tdt}`,
        providesTags: ['FOEReservation']
      }),
      getAvailabiltyWithRateByDate: builder.query<
        any[],
        { fdt: string; tdt: string }
      >({
        query: ({ fdt, tdt }) =>
          `foereservation/availabiltywithrate/${fdt}/${tdt}`,
        providesTags: ['FOEReservation']
      }),
      insertFOEReservation: builder.mutation({
        query: foereservation => ({
          url: `foereservation/`,
          method: 'POST',
          body: foereservation
        }),
        invalidatesTags: ['FOEReservation']
      }),
      updateFOEReservation: builder.mutation({
        query: foereservation => ({
          url: `foereservation/`,
          method: 'PUT',
          body: foereservation
        }),
        invalidatesTags: ['FOEReservation']
      }),
      updateFOEReservationRate: builder.mutation({
        query: foereservation => ({
          url: `foereservation/rate/`,
          method: 'PUT',
          body: foereservation
        }),
        invalidatesTags: ['FOEReservation']
      }),
      updateFOEReservationEARate: builder.mutation({
        query: foereservation => ({
          url: `foereservation/earate/`,
          method: 'PUT',
          body: foereservation
        }),
        invalidatesTags: ['FOEReservation']
      }),
      updateFOEReservationECRate: builder.mutation({
        query: foereservation => ({
          url: `foereservation/ecrate`,
          method: 'PUT',
          body: foereservation
        }),
        invalidatesTags: ['FOEReservation']
      }),
      deleteFOEReservation: builder.mutation({
        query: foereservation => ({
          url: `foereservation/${foereservation.rs_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOEReservation']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOEReservationsQuery,
  useGetFOEReservationByIdQuery,
  useLazyGetFOEReservationByIdQuery,
  useGetFOEReservationByDateQuery,
  useGetFOEReservationByOccDateQuery,
  useGetAvailabiltyWithRateByDateQuery,
  useInsertFOEReservationMutation,
  useUpdateFOEReservationMutation,
  useUpdateFOEReservationRateMutation,
  useUpdateFOEReservationEARateMutation,
  useUpdateFOEReservationECRateMutation,
  useDeleteFOEReservationMutation
} = foereservationApi;

